export { default as AttendanceRules } from './impl/AttendanceRules.jsx';


// WEBPACK FOOTER //
// ./src/components/snippets/ChiefSliderComponent/entities/items/AttendanceRules/index.jsx